module.exports = __webpack_public_path__ + "img/weixiao.c4f4c6d9.gif";